module.exports = __webpack_public_path__ + "static/img/weChatPay.2edb6be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/weChatPay.jpg
// module id = xtRV
// module chunks = 1